export default "__VITE_ASSET__f6975271__"